import React from 'react';
import PropTypes from 'prop-types';

const errorAsset = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      fill="#EA212D"
      fillRule="nonzero"
      d="M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm3 8L8 9 6 7 4 9 3 8l2-2-2-2 1-1 2 2 2-2 1 1-2 2 2 2z"
    />
  </svg>
);

const successAsset = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    width="12"
    height="12"
  >
    <g fill="none" fillRule="evenodd">
      <circle id="a" cx="18" cy="18" r="18" fill="#46AC4E" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M14.8 28L5 18.3l5-4.7 4.8 4.8L25.4 8l5 4.8"
      />
    </g>
  </svg>
);

function Message(props) {
  const { type } = props;

  if (!props.message) {
    return false;
  }

  return (
    <div className="message">
      {type === 'success' ? successAsset : ''}
      {type === 'error' ? errorAsset : ''}
      <span className={`message__text--${type} message__text`}>
        {props.message}
      </span>
    </div>
  );
}

Message.defaultProps = {
  type: 'default',
  message: false
};

Message.propTypes = {
  type: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default Message;



// WEBPACK FOOTER //
// ./src/views/components/newsletters/message.js